"use client";

import { ClaimButtonProps } from "../types";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { DollarSign } from "lucide-react";

export const ClaimButtonTMA = ({
  text,
  variant = "simple",
  buttonVariant = "primary",
  buttonSize = "large",
  disabledText,
  onClick,
  fullWidth = false,
  className,
  showIcon = true,
}: ClaimButtonProps) => {
  const disabled = variant === "disabled";
  const loading = variant === "loading";
  const maintenance = variant === "maintenance";

  return (
    <div
      className={cn("inline-block", {
        "w-full": fullWidth || maintenance,
        "w-auto": !fullWidth && !maintenance,
      })}
    >
      <Button
        onClick={maintenance ? undefined : onClick}
        disabled={disabled}
        loading={loading}
        variant={maintenance ? "secondary" : buttonVariant}
        size={buttonSize}
        className={cn(
          "px-0",
          {
            "w-full": fullWidth || maintenance,
            "w-auto min-w-0": !fullWidth && !maintenance, // min-w-0 to prevent default min-width
            "cursor-not-allowed opacity-70 bg-cede-text-inactive": maintenance,
          },
          className,
        )}
      >
        <div className="flex items-center justify-center gap-2">
          {showIcon && !maintenance && <DollarSign className="w-5 h-5" />}
          <span>{disabled && disabledText ? disabledText : text}</span>
        </div>
      </Button>
    </div>
  );
};
